import { library, config } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faXTwitter, faGoogle, faPix, faFacebookF, faCcVisa, faCcMastercard, faCcAmex, faCcDiscover, faCcJcb, faCcDinersClub } from '@fortawesome/free-brands-svg-icons'
import { faCalendarDays,faClock,  faTrashCan, faCreditCard } from '@fortawesome/free-regular-svg-icons'
import {faRightFromBracket,faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
library.add(faXTwitter, faGoogle, faCreditCard, faCcDinersClub, faPix, faCcVisa, faCcJcb, faCcMastercard, faCcAmex, faCcDiscover, faTrashCan, faFacebookF, faCalendarDays)
library.add( faClock,faRightFromBracket,faExclamationTriangle)
// This is important, we are going to let Nuxt worry about the CSS
config.autoAddCss = false

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('font-awesome-icon', FontAwesomeIcon, {})
})